var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#666",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 5.45454544c-10.1454546 0-18.54545456 8.39999996-18.54545456 18.54545456s8.39999996 18.5454546 18.54545456 18.5454546 18.5454546-8.2909091 18.5454546-18.5454546-8.2909092-18.54545456-18.5454546-18.54545456zm7.9636364 19.19999996c.1090909.9818182-.6545455 1.7454546-1.5272728 1.7454546h-5.7818182c-.3272727.1090909-.7636363 0-1.3090908 0h-.109091c-.9818182 0-1.7454545.3272727-1.7454545-.6545454v-10.4727273c0-.9818182.8727273-1.7454546 1.7454545-1.7454546.9818182 0 1.7454546.8727273 1.7454546 1.7454546v7.5272727h5.2363636c.9818182 0 1.6363636.7636364 1.6363636 1.6363636.109091.109091.109091.2181818.109091.2181818z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.f4b182733e211eef9466f7764a8560a4.svg";
export { ForwardRef as ReactComponent };